
import React, { useState, useCallback, useEffect } from 'react';
import {
  required, minLength, maxLength, minValue, maxValue,
  number, regex, email, choices,
  Edit,
  FunctionField,
  SimpleForm,
  TextInput,
  NumberInput, useNotify, useRedirect,
  ReferenceInput,
  SelectInput, DateField, AutocompleteInput,
  BoolenField,
  NumberField,
  FormDataConsumer, ReferenceField, useRefresh, RichTextField,
  DateInput, ReferenceManyField, Datagrid, TextField,
  BooleanInput, TabbedForm, FormTab,
  BooleanField,
} from "react-admin";

import { useStyles } from "../../formStyles";
import Button from '@material-ui/core/Button';
import CDeleteButton from "../../common/CDeleteButton";
import { makeStyles } from '@material-ui/core/styles';
import { CreateToolbar } from "../../CreateToolbar";
import {AgentInput} from "./component/AgentInput"
import ExpiringInsurerInput from './component/ExpiringInsurerInput';
import ExpiringBrokerInput from './component/ExpiringBrokerInput';
import PolicyExpiryDateInput from "./component/PolicyExpiryDateInput";
import FinilisedPremiumInput from './component/FinilisedPremiumInput';
import CurrentInsurerInput from './component/CurrentInsurerInput';
import RFQDocumentsCreate from "./popup/RFQDocumentsCreate";
import NetPremiumCreate from "./popup/NetPremiumCreate";
import { Authorizer } from "../../common/Authorizer";
import EditIcon from '@material-ui/icons/Edit';
import { FormToolbar } from "../../common/FormToolbar";
import * as apiClient from "../../common/apiClient";
import { Divider, Drawer } from '@material-ui/core';
import PremiumWithLogsButton from "./component/PremiumWithLogsButton";
import QuoteReleaseDateInput from './component/QuoteReleaseDateInput';

export const RfqRegisterEdit = (props) => {

  const classes = useStyles({});

  const propsObj = Authorizer(props);

  const defaultValues = {
    isActive: true,
    revisionCount: 0,
  };
  const [isaddOtherDocuments, setIsAddOtherDocuments] = useState(false);
  const [IsEditRecord, setIsEditRecord] = useState(null);

  const DisplayFileLink = (props) => {
    let { record } = props;

    if (record.docUrl && record.docUrl.length > 0)
      return (
        <a href={record.docUrl}>View File</a>
      )
    else {
      return null
    }
  }
  const onCloseOtherDocumentForm = () => {
    setIsAddOtherDocuments(false);
    refresh();
  }
 const onCancel = () => {
    setIsAddOtherDocuments(false);
  }
  const refresh = useRefresh();
  const handleClose = useCallback(() => {
    setIsAddOtherDocuments(false);
  }, []);

  const myStyles = makeStyles(theme => ({
    root: {
      display: 'flex',
    },
    list: {
      flexGrow: 1,
      transition: theme.transitions.create(['all'], {
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginRight: 0,
    },
    listWithDrawer: {
      marginRight: 300,
    },
    drawerPaper: {
      zIndex: 100,
      marginTop: 50,
      width: 750,
    },
    drawerPaper1500: {
      zIndex: 100,
      marginTop: 50,
      width: 1100,
    },
  }));
  
  const myclasses = myStyles({});

  const requiredExceptBusinessTypeOne = (value, allValues) => {
  if (Number(allValues?.bzTypeId) === 1) {
    return undefined;
  }
    return value ? undefined : 'Required';
 };

const [isAddNetPremium, setIsAddNetPremium] = useState(false);

const onCloseNetPremium = () => {
    setIsAddNetPremium(false);
    refresh();
};

const onCancelNetPremium = () => {
    setIsAddNetPremium(false);
};

const [selectedTab, setSelectedTab] = useState(0);

 return (
  <React.Fragment>
    <Edit title="RFQ Register Edit" {...props} undoable={false}>
        <TabbedForm redirect={false} variant="outlined" toolbar={<FormToolbar {...propsObj} showDelete={false} />} initialTab={selectedTab}>
          <FormTab label="Basic Details">
            {/* <SimpleForm
              variant="outlined"
              redirect="list"
              toolbar={<CreateToolbar {...props} />}
              initialValues={defaultValues}
            > */}
              <TextInput
                source="rfqNo"
                label="RFQ No"
                disabled
                fullWidth
                formClassName={classes.one_three_input}
              />

              <DateInput
                source="receivedDate"
                label="Received Date"
                validate={[required()]}
                fullWidth
                formClassName={classes.two_three_input}
              />

              <DateInput
                source="floatDate"
                label="Float Date"
                validate={[required()]}
                fullWidth
                formClassName={classes.last_three_input}
              />

              <ReferenceInput
                label="Agent Type"
                source="agentTypeId"
                reference="lookups"
                filter={{ type: 'RFQAT' }}
                fullWidth
                formClassName={classes.one_three_input}
                sort={{ field: 'name', order: 'ASC' }}
              >
                <SelectInput optionText="name" />
              </ReferenceInput>

            <AgentInput
                source="agent"
                label="Agent"
                fullWidth
                formClassName={classes.two_three_input}
              />

              <TextInput
                source="customer"
                label="Customer"
                fullWidth
                formClassName={classes.last_three_input}
              />

              <TextInput
                multiline
                source="occupancy"
                label="Occupancy"
                fullWidth
              />

              <ReferenceInput
                label="Buisiness Line Type"
                source="ebTypeId"
                validate={[required()]}
                reference="lookups"
                filter={{ type: 'RFQEB' }}
                sort={{ field: 'name', order: 'ASC' }}
                perPage={1000}
                fullWidth
                formClassName={classes.one_three_input}
              >
                <AutocompleteInput optionText="name" />
              </ReferenceInput>

              <ReferenceInput
                label="Policy Type"
                source="policyTypeId"
                validate={[required()]}
                reference="policy-departments"
                sort={{ field: 'name', order: 'ASC' }}
                perPage={1000}
                fullWidth
                formClassName={classes.two_three_input}
              >
                <AutocompleteInput optionText="name" />
              </ReferenceInput>

              <ReferenceInput
                label="RM"
                source="rmid"
                validate={[required()]}
                reference="employees"
                filter={{ typeId: 98 }}
                perPage={1000}
                enableGetChoices={({ q }) => q && q.length >= 2}
                fullWidth
                sort={{ field: 'name', order: 'ASC' }}
                formClassName={classes.last_three_input}>
                <AutocompleteInput
                  optionText="name"
                  debounce={1000}
                  filterToQuery={q => ({ q })} />
              </ReferenceInput>
              <ReferenceInput
                label="Business Type"
                source="bzTypeId"
                validate={[required()]}
                reference="biz-types"
                sort={{ field: 'name', order: 'ASC' }}
                perPage={1000}
                fullWidth
                formClassName={classes.one_three_input}
              >
                <AutocompleteInput optionText="name" />
              </ReferenceInput>

              <DateInput
                source="inceptionDate"
                label="Inception Date"
                fullWidth
                formClassName={classes.two_three_input}
              />
              <PolicyExpiryDateInput
                formClassName={classes.last_three_input}
              />
              <NumberInput
                source="sumInsured"
                label="Sum Insured"
                fullWidth
                formClassName={classes.one_three_input}
              />

            <PremiumWithLogsButton
                 formClassName={classes.one_three_input}
               onLogsClick={() => {
                    const tabs = document.querySelectorAll('[role="tab"]');

                    tabs.forEach(tab => {
                        if (
                            tab.textContent &&
                            tab.textContent.trim() === "Net Premium Logs"
                        ) {
                            tab.click();
                        }
                    });
                }}
            />
              <QuoteReleaseDateInput formClassName={classes.last_three_input} />

                <ReferenceInput
                  label="Status"
                  source="statusId"
                  validate={[required()]}
                  reference="lookups"
                  filter={{ type: 'RFQST' }}
                  sort={{ field: 'name', order: 'ASC' }}
                  perPage={1000}
                  fullWidth
                  formClassName={classes.one_three_input}
                >
                  <SelectInput optionText="name" />
                </ReferenceInput>

                <ExpiringInsurerInput
                  formClassName={classes.two_three_input}
                  fullWidth
                />

                <ExpiringBrokerInput
                  formClassName={classes.last_three_input}
                  fullWidth
                />

              <DateInput
                source="latestQueryRaisedDate"
                label="Latest Query Raised Date"
                fullWidth
                formClassName={classes.one_three_input}
              />

              <FinilisedPremiumInput
                formClassName={classes.two_three_input}
                fullWidth
              />

              <NumberInput
                source="revisionCount"
                label="Revision Count"
                fullWidth
                formClassName={classes.last_three_input}
              />

              <TextInput
                multiline
                source="additionalRemarks"
                label="Additional Remarks"
                fullWidth
              />

          <CurrentInsurerInput
                formClassName={classes.one_three_input}
                fullWidth
              />

          <BooleanInput
              formClassName={classes.two_three_input}
              source="isActive"
              label="Is Active"
            />


            {/* </SimpleForm> */}
          </FormTab>

        <FormTab label="Net Premium Logs">

          <div style={{ flex: 1 }}>
            <Button
              style={{ marginRight: "10px" }}
              onClick={() => setIsAddNetPremium(true)}
            >
              Add Net Premium
            </Button>
          </div>

          <ReferenceManyField
            fullWidth
            addLabel={false}
            reference="rfq-register-net-premiums"
            target="rfqRegisterId"
            perPage={2000}
            sort={{ field: "id", order: "DESC" }}
          >
            <Datagrid>
               {<CDeleteButton {...props} />}
              <ReferenceField
                label="Financial Year"
                source="finYearId"
                reference="lookups"
                link={false}
              >
                <TextField source="name" />
              </ReferenceField>

              <TextField
                label="Net Premium"
                source="netPremium"
              />

            {/* Is Claim - Read Only Checkbox */}
                <BooleanField
                    label="Is Claim"
                    source="isClaim"
                />

              <TextField
                label="Claim Amount"
                source="claimAmount"
              />

              <BooleanField
                  label="Active"
                  source="isActive"
              />
              <ReferenceField
                label="Created By"
                source="createdBy"
                reference="users"
                link={false}
              >
                <TextField source="userName" />
              </ReferenceField>

              <DateField
                label="Created Date"
                source="createdDate"
                showTime
              />

            </Datagrid>
          </ReferenceManyField>

        </FormTab>

          <FormTab label="Documents">
            {<div style={{ flex: 1 }}>
              <Button style={{ marginRight: "10" }} onClick={() => { setIsAddOtherDocuments(true); }}>Add New Document</Button>

            </div>}
            <ReferenceManyField fullWidth={true}
              addLabel={false}
              sort={{ field: 'id', order: 'ASC' }}
              reference="rfq-register-docs"
              perPage={2000}
              target="rfqRegisterId">
              <Datagrid>
                {<CDeleteButton {...props} />}
                <ReferenceField label="Document Type" source="documentTypeId"
                  reference="document-types" link={false}>
                  <TextField source="name" />
                </ReferenceField>
                <ReferenceField label="File Type" source="typeId"
                  filter={{ type: 'DT' }}
                  reference="lookups" link={false}>
                  <TextField source="name" />
                </ReferenceField>
                <TextField label="Remarks" source="remarks" />
                <DisplayFileLink label="Document URL" source="docUrl" />
                <ReferenceField
                  label="Created By"
                  source="createdBy"
                  reference="users"
                  link={false}
                >
                <TextField source="userName" />
              </ReferenceField>
                <DateField showTime={true} label="Created Date" source="createdDate" locales="fr-FR" />
              </Datagrid>
            </ReferenceManyField>
          </FormTab>
     </TabbedForm>       
    </Edit>
  <Drawer
    anchor="right"
    onClose={handleClose}
    classes={{
      paper: myclasses.drawerPaper1500,
    }}
    open={isAddNetPremium || isaddOtherDocuments}
  >
    {isaddOtherDocuments && (
      <RFQDocumentsCreate
        onClose={onCloseOtherDocumentForm}
        onCancel={onCancel}
        rfqRegisterId={props.id}
        {...props}
      />
    )}

     {isAddNetPremium && (
        <NetPremiumCreate
            onClose={onCloseNetPremium}
            onCancel={onCancelNetPremium}
            rfqRegisterId={props.id}
            {...props}
        />
    )}
  </Drawer>    
  </React.Fragment>
  );
 };